import React from 'react';
import { Button, Tooltip } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { ExportToCsv } from 'export-to-csv';
import { useStyles } from './styles';

const options = {
    fieldSeparator: ',',
    filename: 'case-list',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    title: 'Case List',
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
};

export interface ApplicationsTableExportProps {
    rows: any;
}

export default function ApplicationsTableExport({ rows }: ApplicationsTableExportProps) {
    const classes = useStyles();
    const csvExporter = new ExportToCsv(options);

    return (
        <Tooltip title="Export to csv">
            <Button
                aria-label="Export to csv"
                onClick={() => csvExporter.generateCsv(rows.map(row => row.values))}
                variant="outlined"
                color="default"
                className={classes.button}
                endIcon={<GetAppIcon />}
            >
                Export
            </Button>
        </Tooltip>
    );
}
